import { Expose } from 'class-transformer';

@Expose()
export class Model {
  public id: number;
}
